import React from "react";
import { GameNotificationUserBlock } from "../../../src/server/models/game/modules/notifications/blocks"
import PlayerAvatar from "../../user/avatar";

type Props = {
    block: GameNotificationUserBlock;
}

const SIZE = '16px';

export default function NotificationUser(
    {
        block,
    }: Props,
): React.ReactNode {
    return <span style={{fontWeight: 'bold'}}>
        <PlayerAvatar
            src={block.user.avatar}
            style={{
                maxWidth: SIZE,
                maxHeight: SIZE,
            }}
        />
        &nbsp;
        {block.user.name}
    </span>
}
